/**
 * @module components/marketing/ReviewsCount
 * @description "21,824+ reviews completed" social-proof badge.
 *
 * @extracted-from client/src/App.js (lines ~1710-1732)
 */

import React from 'react';
import { Users } from 'lucide-react';

/**
 * @param {Object} [props]
 * @param {string} [props.count='21,824+'] — Displayed review count.
 */
const ReviewsCount = ({ count = '21,824+' }) => {
  return (
    <div className="flex items-center justify-center mt-16 md:mt-20">
      <div className="inline-flex items-center gap-3 bg-critic-bg-card/35 backdrop-blur-xl rounded-2xl border border-white/[0.08] px-5 md:px-7 py-4 hover:border-white/[0.12] transition-all duration-critic ease-critic-out mx-4 md:mx-0 shadow-[0_16px_48px_rgba(0,0,0,0.2)]">
        <Users className="h-5 w-5 text-apple-blue flex-shrink-0 opacity-90" aria-hidden />
        <div className="flex flex-col sm:flex-row sm:items-baseline sm:gap-2 text-left">
          <span className="font-display text-critic-text-primary font-semibold text-lg md:text-xl tabular-nums tracking-tight">
            {count}
          </span>
          <span className="text-sm text-critic-text-secondary font-normal">reviews completed</span>
        </div>
        <div className="flex -space-x-2">
          <div className="w-6 h-6 bg-gradient-to-r from-apple-blue to-critic-insight-mid rounded-full border-2 border-critic-bg-deep flex items-center justify-center">
            <span className="text-xs text-white font-bold">J</span>
          </div>
          <div className="w-6 h-6 bg-gradient-to-r from-critic-insight-mid to-critic-insight-purple rounded-full border-2 border-critic-bg-deep flex items-center justify-center">
            <span className="text-xs text-white font-bold">C</span>
          </div>
          <div className="w-6 h-6 bg-gradient-to-r from-critic-insight-purple to-apple-purple rounded-full border-2 border-critic-bg-deep flex items-center justify-center">
            <span className="text-xs text-white font-bold">+</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewsCount;
